import {Inject, Pipe, PipeTransform} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';

@Pipe({
  standalone: false,
  name: 'bringozTimeAgo'
})
export class BringozTimeAgoPipe implements PipeTransform {

  constructor(@Inject(TranslateService) private translateService: TranslateService) {}

  transform(timeToCheck: any, defaultValue: string = '---'): string {
    if (!timeToCheck) {
      return defaultValue;
    }

    const today = moment();
    const fromDate = moment(timeToCheck);

    const months = today.diff(fromDate, 'months');
    const days = today.diff(fromDate, 'days');
    const hours = today.diff(fromDate, 'hours');
    const minutes = today.diff(fromDate, 'minutes');
    const seconds = today.diff(fromDate, 'seconds');

    const timeCollection = [
      { key: 'Month', pluralKey: 'Months', difference: months },
      { key: 'Day', pluralKey: 'Days', difference: days },
      { key: 'Hour', pluralKey: 'Hours', difference: hours },
      { key: 'Minute', pluralKey: 'Minutes', difference: minutes },
      { key: 'Second', pluralKey: 'Seconds', difference: seconds }
    ];

    const timeAgoFound = timeCollection.find(time => time.difference !== 0);

    if (!timeAgoFound) {
      return defaultValue;
    }

    const translateKey = timeAgoFound.difference > 0 ? 'X_TIME_AGO' : 'IN_X_TIME';
    const translateParams = {
      value: Math.abs(timeAgoFound.difference),
      unit: Math.abs(timeAgoFound.difference) > 1 ?
        this.translateService.instant(timeAgoFound.pluralKey) :
        this.translateService.instant(timeAgoFound.key)
    };

    return this.translateService.instant(translateKey, translateParams);
  }
}
